module.exports = __webpack_public_path__ + "static/media/notificacion-bkg.28955681.png";